import { render, staticRenderFns } from "./VideoCategoryMergePopup.vue?vue&type=template&id=5ed31e06&"
import script from "./VideoCategoryMergePopup.vue?vue&type=script&lang=js&"
export * from "./VideoCategoryMergePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports